import {
  CardElement,
  useStripe,
  useElements,
  AddressElement,
} from '@stripe/react-stripe-js';
import { UserService } from '../../../service/UserService';

import { Link } from 'react-router-dom';
import { User } from '../../../util/Types/User';
import { useNotificationStore } from '../../../store/storeNotifications';
import KitModal from '../../UI/KitModal';
import { Box, Button, Typography } from '@mui/material';
import { StripeLogo } from '@phosphor-icons/react';
type Props = {
  onHide: () => void;
  show: boolean;
  setNewMethod: (value: boolean) => void;
  setAuthUser: (value: User | null) => void;
  authUser: User;
  setDefaultPaymentMethodId?: (value: string) => void;
};

const CreatePaymentMethodModal = ({
  onHide,
  show,
  setNewMethod,
  setAuthUser,
  authUser,
  setDefaultPaymentMethodId,
}: Props) => {
  const stripe = useStripe();
  const elements = useElements();
  const setNotification = useNotificationStore(state => state.setNotification);
  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (!stripe || !elements) {
      setNotification({
        type: 'error',
        message: 'Something went wrong',
      });

      return;
    }

    const response: any = await elements.getElement(AddressElement)?.getValue();
    if (response.complete === false) {
      return;
    }
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement)!,
      billing_details: {
        name: response?.value.name,
        address: response.value.address,
        phone: response.value.phone,
      },
    });

    if (error) {
      setNotification({
        type: 'error',
        message: error.message || 'Something went wrong',
      });

      return;
    }

    await UserService.attachPaymentMethod(paymentMethod?.id!, {
      brand: paymentMethod?.card?.brand!,
      exp_month: paymentMethod?.card?.exp_month!,
      exp_year: paymentMethod?.card?.exp_year!,
      last4: paymentMethod?.card?.last4!,
      billing_details: {
        name: paymentMethod?.billing_details?.name!,
      },
    });
    await UserService.setDefaultPaymentMethod(paymentMethod?.id!);

    setAuthUser({
      ...authUser,
      defaultPaymentMethod: paymentMethod?.id!,
    });

    elements.getElement(AddressElement)!.clear();
    elements.getElement(CardElement)!.clear();

    setDefaultPaymentMethodId && setDefaultPaymentMethodId(paymentMethod?.id!);
    setNewMethod(true);
    onHide();
  };

  return (
    <KitModal
      show={show}
      onHide={onHide}
      fullWidth
      title='Add Payment Method'
      footer={
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          width={'100%'}
        >
          <Link target='_blank' to={'/legal/privacy-policy'}>
            Privacy Policy
          </Link>
          <Typography variant='h3'>
            <StripeLogo style={{ color: '#3b5998' }} fontSize={30} /> Powered by
            Stripe
          </Typography>
        </Box>
      }
    >
      <>
        <form onSubmit={handleSubmit}>
          <AddressElement
            options={{
              mode: 'billing',
              fields: {
                phone: 'always',
              },
              validation: {
                phone: {
                  required: 'always',
                },
              },
            }}
            className='mb-3'
          />

          <CardElement
            className='payment'
            options={{
              hidePostalCode: true,
            }}
          />
          <Box>
            <Button
              style={{
                backgroundColor: '#3b5998',
                border: 'none',
                color: 'white',
                padding: '15px 32px',
                textAlign: 'center',
                textDecoration: 'none',
                fontSize: '16px',
                margin: '20px auto',
                maxWidth: '400px',
                width: '100%',
              }}
              fullWidth
              type='submit'
              disabled={!stripe}
            >
              Add Method
            </Button>
          </Box>
        </form>
      </>
    </KitModal>
  );
};

export default CreatePaymentMethodModal;
